export const getSendAsEmailFormDefaultValues = () => {
  return {
    attachmentUuids: [],
    ccEmailRecipients: [],
    emailRecipients: [],
    emailSubject: '',
    emailMessage: '',
    shouldSendCopyToMyself: false,
  }
}
